import selectFolder from './selectFolder';
import selectDefaultFolder from './selectDefaultFolder';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isFolderInFavorites } from 'owa-favorites';
import type { ActionSource } from 'owa-mail-store';
import isValidMailFolder from 'owa-mail-store/lib/utils/isValidMailFolder';
import { getUserConfiguration } from 'owa-session-store';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

export default function (folderIdToSelect: string, actionSource: ActionSource): void {
    // folderIdToSelect could be distinguished folderId like 'inbox', 'sentitems'
    const folderId =
        folderNameToId(folderIdToSelect as DistinguishedFolderIdName) || folderIdToSelect;

    // Invalid Id specified in the URL, fallback to default folder
    if (!isValidMailFolder(folderId)) {
        selectDefaultFolder(actionSource);
        return;
    }

    //special case - if folder selected in favorites and favorites tree is collapsed - fall back to primary folder tree
    const isFavoritesFolderTreeCollapsed =
        getUserConfiguration()?.UserOptions?.IsFavoritesFolderTreeCollapsed;

    // Valid folder in favorites
    if (isFolderInFavorites(folderId) && !isFavoritesFolderTreeCollapsed) {
        selectFolder(folderId, 'favorites' /* treeType */, actionSource);
        return;
    }

    // Valid folder not in favorites
    selectFolder(folderId, 'primaryFolderTree' /* treeType */, actionSource);
}
